import React, { useEffect, useRef, useState } from 'react';
import { BrowserMultiFormatReader } from '@zxing/library';
import getIdFromScanResult from './getIdFromScanResult';
import { t } from 'i18next';
import ScanInputPermissionsModal from './ScanInputPermissionsModal';
import { getScanCamera } from '../../../helpers/helpers';

const ScanInput = ({ onScannResult }) => {

    const [dimissedError, setDimissedError] = useState(false);

    const [denidedError, setDenidedError] = useState(false);

    const [scanError, setScanError] = useState(false);

    const errorHandler = {
        'Permission dismissed': () => setDimissedError(true),
        'Permission denied': () => setDenidedError(true)
    }

    const videoRef = useRef(null);

    const codeReader = new BrowserMultiFormatReader();

    const userCamera = getScanCamera();

    const startScanning = async () => {
        try {
            await codeReader.decodeFromVideoDevice(userCamera, videoRef.current, (result, error) => {
                if (result) {
                    const idResult = getIdFromScanResult(result.text);
                    if (idResult !== undefined) {
                        setScanError(false);
                        onScannResult(idResult)
                    } else {
                        setScanError(true);
                    }
                }
                // if (error) {
                //     console.error('Error:', error);
                // }
            });
        } catch (error) {
            console.error(error);
            errorHandler[error.message]();
            // Aquí puedes mostrar un mensaje de error en la interfaz de usuario
        }
    };

    useEffect(() => {
        startScanning();
        return () => {
            codeReader.reset();
        };
        // eslint-disable-next-line
    }, [userCamera]);

    if (dimissedError) {
        return (
            <ScanInputPermissionsModal
                showModal={dimissedError}
                setShowModal={() => setDimissedError(!dimissedError)}
                message={t('TO_USE_CAMERA_NEED_PERMISSIONS')}
                onClick={startScanning}
                closeButtonText={t('DENY')}
            />
        );
    };

    if (denidedError) {
        return (
            <ScanInputPermissionsModal
                showModal={denidedError}
                setShowModal={() => setDenidedError(!denidedError)}
                message={t('TO_USE_CAMERA_NEED_PERMISSIONS')}
                closeButtonText={'Ok'}
            />
        )
    };

    if (!dimissedError && !denidedError) {
        return (
            <div className="embed-responsive embed-responsive-16by9 d-flex justify-content-center">
                <ScanInputPermissionsModal
                    showModal={scanError}
                    setShowModal={() => setScanError(!scanError)}
                    message={t('SCAN_ERROR')}
                    closeButtonText={'Ok'}
                />
                <div className="border-video">
                    <video
                        ref={videoRef}
                        style={{ maxHeight: '590px', maxWidth: '100%' }}
                    />
                </div>
            </div>
        );
    }
}

export default ScanInput